module.exports = __webpack_public_path__ + "assets/img/f61c2fc8e3637c54d726b9080c36100d.webp";